import { useState } from "react";
import useEvaApi, { EvaApiCall } from "../../../hooks/useEvaApi";
import VersteijnenConfigsPageView from "./VersteijnenConfigsPageView";
import useCustomEffect from "../../../hooks/useCustomEffect";

function VersteijnenConfigsPage() {
  const callEvaApi = useEvaApi();

  const [configData, setConfigData] = useState({
    id: null,
    active: false,
    url: "",
    username: "",
    password: "",
    sender_uuid: "",
    message_type_code: "",
    report_id: "",
  });
  const [submitError, setSubmitError] = useState(null);

  /**
   * initialize the component
   */
  useCustomEffect(() => {
    fetchConfigData();
  }, []);

  /**
   * This method will fetch the Versteijnen config data from the API
   */
  async function fetchConfigData() {
    await callEvaApi(
      new EvaApiCall("integrations/versteijnen/configs")
        .setLoadingGroup("versteijnen_configs_page_fetch")
        .setAlertError(true)
        .setOnSuccess((response) => {
          const data = response.data.data;
          if (!data) return;

          setConfigData(getConfigDataFromApiResponse(data));
        }),
    );
  }

  /**
   * This method will update the active state on input change
   * @param {bool} value
   */
  function onActiveChange(value) {
    setConfigData({
      ...configData,
      active: value,
    });
  }

  /**
   * This method will update the url on input change
   * @param {event} e
   */
  function onUrlChange(e) {
    setConfigData({
      ...configData,
      url: e.target.value,
    });
  }

  /**
   * This method will update the username on input change
   * @param {event} e
   */
  function onUsernameChange(e) {
    setConfigData({
      ...configData,
      username: e.target.value,
    });
  }

  /**
   * This method will update the password on input change
   * @param {event} e
   */
  function onPasswordChange(e) {
    setConfigData({
      ...configData,
      password: e.target.value,
    });
  }

  /**
   * This method will update the sender uuid on input change
   * @param {event} e
   */
  function onSenderUuidChange(e) {
    setConfigData({
      ...configData,
      sender_uuid: e.target.value,
    });
  }

  /**
   * This method will update the message type code on input change
   * @param {event} e
   */
  function onMessageTypeCodeChange(e) {
    setConfigData({
      ...configData,
      message_type_code: e.target.value,
    });
  }

  /**
   * This method will update the report id on input change
   * @param {event} e
   */
  function onReportIdChange(e) {
    setConfigData({
      ...configData,
      report_id: e.target.value,
    });
  }

  /**
   * This method will submit the form
   */
  async function onSubmit() {
    await callEvaApi(
      new EvaApiCall("integrations/versteijnen/configs")
        .setMethod("PUT")
        .setData(configData)
        .setLoadingGroup("versteijnen_configs_page_save")
        .setAlertError(true)
        .setErrorState(setSubmitError)
        .setAlertSuccess(true)
        .setOnSuccess((response) => {
          const data = response.data.data;
          if (!data) return;

          setConfigData(getConfigDataFromApiResponse(data));
        }),
    );
  }

  /**
   * This method will map the API response to the config data structure
   * @param {object} data
   * @returns {object}
   */
  function getConfigDataFromApiResponse(data) {
    return {
      id: data.id,
      active: data.active,
      url: data.url,
      username: data.username,
      password: data.password,
      sender_uuid: data.sender_uuid,
      message_type_code: data.message_type_code,
      report_id: data.report_id,
    };
  }

  return (
    <VersteijnenConfigsPageView
      configData={configData}
      submitError={submitError}
      setConfigData={setConfigData}
      onSubmit={onSubmit}
      onActiveChange={onActiveChange}
      onUrlChange={onUrlChange}
      onUsernameChange={onUsernameChange}
      onPasswordChange={onPasswordChange}
      onSenderUuidChange={onSenderUuidChange}
      onMessageTypeCodeChange={onMessageTypeCodeChange}
      onReportIdChange={onReportIdChange}
    />
  );
}

export default VersteijnenConfigsPage;